



















































































































































import { fetchSolicitud } from '../fetchSolicitud';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';

import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';

import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    DatePicker,
  },
})
export default class General extends ComponenteBaseStepper {
  @Prop({ required: true }) editedItem: any;
  @Prop({ required: true }) motivos: any[];
  validForm: boolean = true;

  permisosActuales: PermisoAccionVm[] = [];
  permisosTotales: PermisoAccionVm[] = [];
  destinosPosibles: any = [];

  findFilterList({ key }: { key: string }) {
    return this.motivos.filter(x => x[key] !== 't');
  }

  async postEdicion(): Promise<Boolean> {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitud(
      {
        numero: this.nuevodato.numero,
        estado: this.nuevodato.estado,
        motivo: this.nuevodato.motivo,
        observacion: this.nuevodato.observacion,
        usuarioId: JSON.parse(window.localStorage.user).id,
        clienteId: this.clienteId,
      },
      'solicitud_baja_sim_por_tarjeta/editar_solicitud'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrio un error al editar la solicitud', {
          timeout: 3000,
        });
        this.loadingService.hideLoading();
        return false;
      });
  }

  nuevodato: any;
  async grabarEdicion() {
    this.nuevodato = {
      numero: this.formFields.numero.value,
      motivo: this.formFields.motivo.value,
      observacion: this.formFields.observacion.value,
      estado:
        this.data.estado != this.formFields.estado.value
          ? this.formFields.estado.value
          : '',
    };
    let edicion = await this.postEdicion();
    if (edicion) {
      this.$emit('editado', edicion);
    }
  }

  async getSolicitudSeleccionada() {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitud(
      { solicitud: this.editedItem },
      'solicitud_baja_sim_por_tarjeta/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar la solicitud', {
          timeout: 3000,
        });
        this.loadingService.hideLoading();
      });
  }

  data: any;
  isAnulado: boolean = false;
  isEjecutado: boolean = false;
  async cargarDatos() {
    let getSolicitud = await this.getSolicitudSeleccionada();
    this.data = getSolicitud[0];
    this.formFields.numero.value = this.data.sbajasimnumero;
    this.formFields.usuario.value = this.data.fullname;
    this.formFields.estado.value = this.data.estado;
    this.formFields.observacion.value = this.data.sbajasimobs;
    if (this.data.estado == 'Anulado') {
      this.isAnulado = true;
    }
    if (this.data.estado == 'Ejecutado') {
      this.isEjecutado = true;
    }
    if (this.data.bajaclinumero != '') {
      this.isAnulado = true;
    }
    this.formFields.cantidad.value = this.data.sbajacantsim;
    this.formFields.motivo.value = this.data.motiid;
    this.formFields.usuarioModificacion.value = this.data.full_name_modifica;
    this.formFields.numeroBajaCliente.value = this.data.bajaclinumero;
    this.formFields.fechaModificacion.value = this.data.sbajasimfecha_modifica
      ? moment(this.data.sbajasimfecha_modifica).format('YYYY/MM/DD HH:mm')
      : '';
  }
  estadosEditables: any = ['Anulado', 'Solicitado'];
  mounted() {
    this.cargarDatos();
  }

  rules = {
    required: (value: any) => !!value || 'Required.',
  };

  formFields: {
    numero: any;
    usuario: any;
    motivo: any;
    estado: any;
    cantidad: any;
    observacion: any;
    usuarioModificacion: any;
    fechaModificacion: any;
    numeroBajaCliente: any;
  } = {
    numero: {
      label: 'Número',
      value: '',
    },
    usuario: {
      label: 'Usuario',
      value: '',
    },
    motivo: {
      label: 'Motivo (Obligatorio)',
      value: '',
    },
    estado: {
      label: 'Estado',
      value: 'Solicitado',
    },
    cantidad: {
      label: 'Cantidad',
      value: 0,
    },
    observacion: {
      label: 'Observación',
      value: '',
    },
    usuarioModificacion: {
      label: 'Usuario Modificación',
      value: '',
    },
    fechaModificacion: {
      label: 'Fecha Modificación',
      value: '',
    },
    numeroBajaCliente: {
      label: 'Baja Cliente Asociada',
      value: '',
    },
  };

  // Globales
  $snotify: any;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
